import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: { display: 'inline-block' },
  systemRoot: {
    width: props => (props.isMobileView ? `${props.windowWidth + 30}px` : `${props.windowWidth * 57 / 100}px`),
    padding: theme.spacing(2, 1.25, 0, 2)
  },
  lrcRoot: {
    width: props => (props.isMobileView ? `${props.windowWidth + 30}px` : `${props.windowWidth * 43 / 100}px`),
    padding: theme.spacing(0.75, 2, 0, 0),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2)
    }
  },
  lrcTable: {
    borderRadius: 0,
    borderTop: '1px solid black',
    overflow: 'hidden',
    marginTop: theme.spacing(0.25)
  },
  header: {
    border: 'none',
    padding: theme.spacing(1),
    backgroundColor: '#bcbcbc40',
    color: '#9B9B9B',
    fontWeight: 'bold',
    fontSize: 14,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    width: theme.spacing(15),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    position: 'relative',
    minWidth: theme.spacing(17)
  },
  largeText: {
    minWidth: theme.spacing(26)
  },
  subTextHeader: { paddingBottom: 0 },
  paginationContainer: {
    '& .Mui-disabled': { color: theme.palette.primary.dataBlack }
  },
  paginationFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(3, 2),
    borderTop: `1px solid ${theme.palette.secondary[300]}`,
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      paddingLeft: theme.spacing(1)
    }
  },
  tableContainer: { minHeight: theme.spacing(40) },
  tableData: {
    fontSize: 14,
    padding: theme.spacing(1.5, 1),
    border: 'none',
    whiteSpace: 'nowrap',
    maxWidth: theme.spacing(20),
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  checkBoxTableData: {
    fontSize: 14,
    padding: '11.5px 8px',
    border: 'none',
    width: theme.spacing(15),
    '& *': { fontSize: 14 }
  },
  tableRow: { borderBottom: '1px solid #70707047' },
  label: {
    color: theme.palette.primary.lightBlack,
    fontSize: 12,
    paddingLeft: theme.spacing(0.5)
  },
  important: { color: 'red' },
  labelWrapper: { display: 'flex', paddingBottom: theme.spacing(1) },
  tableHeading: {
    display: 'flex',
    fontSize: 14
  },
  checkboxLabel: {
    fontSize: 12,
    color: theme.palette.primary.lightBlack,
    textTransform: 'capitalize'
  },
  checkboxWrapper: { display: 'flex', alignItems: 'center' },
  icon: { width: theme.spacing(2.5), height: theme.spacing(2.5) },
  checkbox: {
    padding: 0,
    marginRight: theme.spacing(1),
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    borderRadius: 0
  },
  inputField: {
    backgroundColor: theme.palette.primary.white,
    height: theme.spacing(3.5),
    width: '100%'
  },
  price: { width: 'auto' },
  headerHelpIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5)
  },
  headerWrapper: { display: 'flex', alignItems: 'center' },
  subTextHeaderWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column'
  },
  subText: {
    fontWeight: 500,
    fontSize: 12,
    textTransform: 'lowercase',
    lineHeight: 1
  },
  headerTitle: { fontWeight: 'bold', fontSize: 14 },
  priceWrapper: { display: 'flex', alignItems: 'center' },
  priceHelpIcon: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    paddingLeft: theme.spacing(0.5)
  },
  colorWrapper: { display: 'flex', alignItems: 'center' },
  err: { color: 'red' },
  loader: { textAlign: 'center' },
  greyOut: { color: 'grey' },
  disableCheckbox: {
    opacity: 0.5
  },
  disableTableRow: {
    pointerEvents: 'none',
    opacity: 0.5
  },
  menuList: {
    fontSize: 12
  },
  formControl: { minWidth: 120, maxWidth: 300, marginRight: theme.spacing(2.5) },
  systemHeaderWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(1.5)
  },
  systemTableHeading: {
    display: 'flex',
    fontSize: 14
  },
  elevation: {
    overflowX: 'auto'
  },
  tooltipText: {
    fontSize: 14,
    color: theme.palette.primary.lightBlack,
    lineHeight: 1.5,
    padding: theme.spacing(1)
  },
  toolWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  searchHeader: {
    paddingTop: 0,
    position: 'relative'
  },
  purchased: {
    color: '#21CB03',
    display: 'flex',
    alignItems: 'center',
    fontSize: 13,
    letterSpacing: 0.07,
    fontWeight: 'bold',
    '& svg': {
      fill: '#21CB03',
      width: theme.spacing(2),
      height: theme.spacing(2),
      marginRight: theme.spacing(0.25)
    }
  },
  toogleWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButtonBase-root': {
      color: theme.palette.primary.main
    },
    '& .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.main
    }
  },
  switchHeaderWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(0.75)
  },
  switchLabel: {
    fontSize: 14,
    color: '#B9B9B9'
  },
  eligibleHelpIcon: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    paddingLeft: theme.spacing(0.5)
  },
  installerInfoIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    paddingLeft: theme.spacing(0.5),
    cursor: 'pointer'
  },
  activeLabel: {
    color: '#545456'
  },
  mobileSystemHeader: {
    flexDirection: 'column',
    alignItems: 'center'
  },
  mobileFormControl: {
    marginRight: 0,
    maxWidth: theme.spacing(15),
    minWidth: theme.spacing(10)
  },
  mobileSwitchHeader: {
    margin: '11px 0px'
  },
  sortIconButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0
  },
  installDateDropdown: {
    height: theme.spacing(3.5),
    backgroundColor: '#FFFFFF',
    width: '100%',
    borderRadius: 0,
    pointerEvents: 'none'
  },
  dateRangeWrapper: {
    boxShadow: 'none',
    padding: '0px !important'
  },
  okButton: {
    color: '#fff'
  },
  installDateField: {
    position: 'absolute',
    zIndex: 1,
    width: 'calc(100% - 24px)',
    height: theme.spacing(3),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(0.25),
    overflow: 'hidden',
    cursor: 'pointer',
    textTransform: 'capitalize',
    color: '#000000de'
  },
  downloadAgreementIcon: {
    cursor: 'pointer',
    padding: theme.spacing(0, 1.5),
    '&:hover': {
      background: 'none'
    }
  },
  downloadAgreement: {
    padding: theme.spacing(0, 2)
  }
}));

export default useStyles;
